__turbopack_context__.v({
  "density-comfortable": "ReportTable-module__2jSJyq__density-comfortable",
  "density-compact": "ReportTable-module__2jSJyq__density-compact",
  "density-spacious": "ReportTable-module__2jSJyq__density-spacious",
  "empty": "ReportTable-module__2jSJyq__empty",
  "row": "ReportTable-module__2jSJyq__row",
  "scroller": "ReportTable-module__2jSJyq__scroller",
  "sortIndicator": "ReportTable-module__2jSJyq__sortIndicator",
  "table": "ReportTable-module__2jSJyq__table",
  "td": "ReportTable-module__2jSJyq__td",
  "tfoot": "ReportTable-module__2jSJyq__tfoot",
  "th": "ReportTable-module__2jSJyq__th",
  "thead": "ReportTable-module__2jSJyq__thead",
  "tr": "ReportTable-module__2jSJyq__tr",
});
